/**
 * Module-level holder for the current session id.
 */
let currentSessionId: string | undefined

export function setFaroSessionId(sessionId: string | undefined): void {
  currentSessionId = sessionId
}

export function getFaroSessionId(): string {
  return currentSessionId ?? 'unknown'
}
